import * as qs from "query-string-for-all";
import * as React from "react";
import AreaSection from "./report/councilArea";
import axios from "axios";
import CouncilsHeader from "./CouncilsHeader";
import ExpenditureSection from "./report/councilExpenditure";
import FinanceSection from "./report/councilFinances";
import Loading from "./general/Loading";
import SustainabilitySection from "./report/councilSustainability";
import { baseUrl } from "../constants/ApiSettings";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { fetchYears, setCouncils } from "src/actions";

import { ICouncil } from "src/interfaces";
import ReportHeader from "./Header"
import SideNavbar from './general/SideNavbar';
import Footer from './Footer';
import { defaultYear } from "src/constants/ApiSettings";

interface IProps {
  fetchYears: (years: string[]) => void;
  setCouncils: (councils: ICouncil[]) => void;
  location: any;
  councils: ICouncil[];
  defaultYear: string;
  where: string|null;
  whoOpened: string|null;
}

class Report extends React.PureComponent<IProps, {}> {
  public componentDidMount() {
    // First of all, grab the years for the year selects
    axios
      .get(`${baseUrl}/years`)
      .then(response => {
        this.props.fetchYears(response.data);
      })
      // tslint:disable-next-line:no-console
      .catch(err => console.error(err));

    // While that happens, we should also fetch basic data about each of our selected councils
    const params = { ...qs.parse(this.props.location.search) };
    const ids = [];
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        ids.push(params[key]);
      }
    }
    const queryString = qs.stringify({
      id: ids
    });
    axios
      .get(`${baseUrl}/councils?${queryString}`)
      .then(res => {
        const { data } = res;
        const primary = data
          .map((council: any) => ({ id: council.id, name: council.string }))
          .find(
            (council: ICouncil) =>
              params.primaryCouncil &&
              council.id === parseInt(`${params.primaryCouncil}`, 10)
          );

        const others = data
          .map((council: any) => ({ id: council.id, name: council.string }))
          .filter(
            (council: ICouncil) =>
              params.primaryCouncil &&
              council.id !== parseInt(`${params.primaryCouncil}`, 10)
          );
        this.props.setCouncils([primary, ...others]);
      })
      // tslint:disable-next-line:no-console
      .catch(err => console.error(err));
  }

  public render() {

    // Wait until we have managed to contact the API before we show anything at all
    if (!this.props.councils[0]) {
      return (
        <section className="w-full h-screen flex flex-col items-center justify-center font-montserrat overflow-hidden">
          <Loading />
        </section>
      );
    }

    return (
      <div className="font-montserrat overflow-hidden">
        <ReportHeader />
        <SideNavbar whoOpened={this.props.whoOpened} where={this.props.where} councils={this.props.councils} />
        <CouncilsHeader />
        <AreaSection />
        <FinanceSection />
        <ExpenditureSection />
        <SustainabilitySection />
        <Footer />
      </div>
    );
  }
  // private adjust = () => {
  //   const nav = document.getElementById("sidenav")
  //   if (nav) {
  //     nav.style.width = (nav.style.width !== "250px" ? "250px" : "0px");
  //   }
  // }
}

const mapStateToProps = (state: any) => ({
  defaultYear:
    state.selectables.years.length > 0 ? defaultYear : null,
  councils: state.selected.councils,
  where: state.navbar.where,
  whoOpened: state.navbar.whoOpened
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchYears: (years: string[]) => dispatch(fetchYears(years)),
  setCouncils: (councils: ICouncil[]) =>
    dispatch(setCouncils(councils))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Report);



// WEBPACK FOOTER //
// ./src/components/ReportScreen.tsx